import { render, staticRenderFns } from "./TestDetailsMockTest.vue?vue&type=template&id=48f2ce28"
import script from "./TestDetailsMockTest.vue?vue&type=script&lang=js"
export * from "./TestDetailsMockTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports